/* eslint import/prefer-default-export: 0 */
import AppIntegrationsProcessor from 'common/repositoryProcessors/-RFC.appIntegrationsProcessor';
import AppInstancesProcessor from 'common/repositoryProcessors/-RFC.appInstancesProcessor';
import AppIntegrationsInactiveProcessor from 'common/repositoryProcessors/-RFC.appIntegrationsInactiveProcessor';
import DevicesProcessor from 'common/repositoryProcessors/-RFC.devicesProcessor';
import IssuesProcessor from 'common/repositoryProcessors/-RFC.issuesProcessor';
import LicensesProcessor from 'common/repositoryProcessors/-RFC.licensesProcessor';
import ActivationCodesProcessor from 'common/repositoryProcessors/-RFC.activationCodesProcessor';
import AppPricesProcessor from 'common/repositoryProcessors/-RFC.appPricesProcessor';
import ExpiredLicensesProcessor from 'common/repositoryProcessors/-RFC.expiredLicensesProcessor';

export {
    AppIntegrationsProcessor,
    AppInstancesProcessor,
    AppIntegrationsInactiveProcessor,
    DevicesProcessor,
    IssuesProcessor,
    LicensesProcessor,
    ActivationCodesProcessor,
    AppPricesProcessor,
    ExpiredLicensesProcessor,
};



// WEBPACK FOOTER //
// ./scripts/common/repositoryProcessors/index.js